import { Fragment, useEffect, useRef, useState } from "react";
import WeeklCalendarComponent from "../components/Calendar/WeeklCalendarComponent";
import { load_quotes_calendar } from "../actions/agenda_content";
import WeekHeader from "../components/Calendar/WeekHeader";
import CalendarModalHandler from "../components/Calendar/CalendarModalHandler";
const WeekCalendar = ({ profileId = "" }) => {
  const calendarRef = useRef(null);
  const [modalInfo, setModalInfo] = useState({
    show: false,
    quoteId: "",
  });

  const [calendarEvents, setCalendarEvents] = useState([]);
  const [isCalendarReady, setIsCalendarReady] = useState(false);
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return `${year}-${month}-${day}`;
  };
  const fetchCalendarQuotes = async (calendarDates) => {
    const { start_date, end_date } = calendarDates;
    if (profileId) {
      const data = await load_quotes_calendar({
        start_date: start_date,
        end_date: end_date,
        professional: profileId,
      });
      if (data) {
        setCalendarEvents(data);
      }
    }
  };
  const handleCalendarChange = (calendarDates) => {
    fetchCalendarQuotes(calendarDates);
  };
  const handleEventEdit = (clickInfo) => {
    setModalInfo({
      quoteId: clickInfo.event.id,
      show: true,
    });
  };
  const handleEventCreate = () => {
    setModalInfo({
      show: true,
      quoteId: null,
    });
  };

  useEffect(() => {
    const calendarApi = calendarRef.current.getApi();
    calendarApi.removeAllEvents();
    calendarApi.addEventSource([...calendarEvents]);
    const startEndDates = {
      start_date: formatDate(calendarApi.view.activeStart),
      end_date: formatDate(calendarApi.view.activeEnd),
    };

    fetchCalendarQuotes(startEndDates);
    if (calendarRef.current) {
      setIsCalendarReady(true);
    }
  }, [calendarRef.current]);
  return (
    <Fragment>
      {isCalendarReady && (
        <WeekHeader
          calendarRef={calendarRef}
          addEvent={handleEventCreate}
          formatDate={formatDate}
          handleCalendarChange={handleCalendarChange}
        />
      )}
      <WeeklCalendarComponent
        events={calendarEvents}
        handleEventEdit={handleEventEdit}
        calendarRef={calendarRef}
      />
      <CalendarModalHandler modalInfo={modalInfo} setModalInfo={setModalInfo} />
    </Fragment>
  );
};

export default WeekCalendar;
